import styles from './PictureTemplate.css';
import { jsx as _jsx } from "react/jsx-runtime";
export const PictureTemplate = props => {
  const {
    imageURL,
    alt,
    width,
    reference
  } = props;
  return /*#__PURE__*/_jsx("a", {
    className: styles['container'],
    href: reference,
    rel: "noreferrer noopener nofollow",
    style: {
      width
    },
    target: "_blank",
    children: /*#__PURE__*/_jsx("img", {
      alt: alt,
      className: styles['image'],
      src: imageURL
    })
  });
};